import { useMemo } from 'react'

import {
  type GetInputContainerStylesProps,
  type GetInputStylesProps,
  getInputContainerClassName,
  getInputStyles,
} from './styles.ts'

export type UseInputStylesProps = GetInputStylesProps &
  GetInputContainerStylesProps

export const useInputStyles = ({
  disabled,
  hasError,
  hasLeftIcon,
  hasRightIcon,
  hasSuccess,
  hasWarning,
  readOnly,
  size,
  multiline,
}: UseInputStylesProps) => {
  const inputClassName = useMemo(
    () =>
      getInputStyles({
        size,
        hasLeftIcon,
        hasRightIcon,
        multiline,
      }),
    [size, hasLeftIcon, hasRightIcon, multiline]
  )

  const inputContainerClassName = useMemo(
    () =>
      getInputContainerClassName({
        disabled,
        hasError,
        hasSuccess,
        hasWarning,
        readOnly,
      }),
    [disabled, hasError, hasSuccess, hasWarning, readOnly]
  )

  return { inputClassName, inputContainerClassName }
}
